"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _CharacterLock = _interopRequireDefault(require("@rsuite/icon-font/lib/people/CharacterLock"));

// Generated by script, don't edit it please.
var CharacterLock = (0, _createSvgIcon["default"])({
  as: _CharacterLock["default"],
  ariaLabel: 'character lock',
  category: 'people',
  displayName: 'CharacterLock'
});
var _default = CharacterLock;
exports["default"] = _default;
module.exports = exports.default;